'use client';

import { createInstance, type Resource } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { initTranslations } from './initTranslations';

type TranslationProviderProps = {
  locale: string;
  namespaces: Array<string>;
  resources?: Resource;
  token?: string;
};

export function TranslationsProvider({
  children,
  token,
  locale,
  namespaces,
  resources,
}: React.PropsWithChildren<TranslationProviderProps>) {
  const i18n = createInstance();
  initTranslations(token, locale, namespaces, i18n, resources);
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
